const getCookieValue = (name) => {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const parts = cookie.split("=");
    if (parts[0] === name) {
      return parts[1];
    }
  }
  return null;
};
const validCoupons = [
  "HVTA8VV2ZQ5D",
  "EC94N6AQYE5T",
  "9Y2CH1030HAE",
  "6JXQD0ABV9W5",
  "DB36NVFT0K29",
  "KS0JJEN5SCP8",
  "NPNVBR4KCCP4",
  "H2N19PJG7BDE",
  "JNEMCTGGE78G",
  "74W6BD9R16JH",
  "CKGHZMVBTPFM",
  "PCDFSEVEEX9E",
  "XFZGYNMSB2T8",
  "WDCCVHKP3ER4",
  "T6M058QX6SEM",
  "MT6YZNXC0Q6R",
  "WDCCVHKP3ER4",
  "E2XS0E20ZZ13",
  "3YFTTPSATS9G",
];

(() => {
  if (validCoupons.indexOf(getCookieValue("discount_code")) >= 0) {
    console.log("detected exclusive member");
    document.cookie = "is_exclusive_member=true; path=/";
  }
})();

const updateElements = () => {
  const elements = document.querySelectorAll(".card__badge, .top, .left");
  console.log(`Detected: ${elements.length}`);
  elements.forEach((element) => {
    element.innerHTML =
      '<span class="badge badge--bottom-left color-scheme-e5d69d02-412d-46ca-b46a-e53c28a628ca">招待特別割引</span>';
  });
};

window.onload = () => {
  if (getCookieValue("is_exclusive_member")) {
    updateElements();
  }
};
